import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '@/store/hooks';
import { selectIsWidgetConfigurationSidebarOpen } from '@/features/dashboard/dashboardSlice';

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background: var(--overlay-light-50);
  position: absolute;
  top: 0;
  z-index: 1;
`;

export const SelectedWidgetOverlay = () => {
  const isVisible = useAppSelector(selectIsWidgetConfigurationSidebarOpen);

  if (!isVisible) return null;

  return <Overlay />;
};
